import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { Layout } from "./components/layout/Layout";
import Landing from "./pages/Landing";
import Pricing from "./pages/Pricing";
import FramingTips from "./pages/FramingTips";
import MatCuttingTips from "./pages/MatCuttingTips";
import Aesthetics from "./pages/Aesthetics";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Account from "./pages/Account";
import Contact from "./pages/Contact";
import AdminMessages from "./pages/AdminMessages";
import AuthCallback from "./pages/AuthCallback";
import FrameCalculator from "./components/FrameCalculator";

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth return before any other route/auth logic runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/calculator" element={<FrameCalculator />} />
        <Route path="/framing-tips" element={<FramingTips />} />
        <Route path="/mat-cutting-tips" element={<MatCuttingTips />} />
        <Route path="/aesthetics" element={<Aesthetics />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/account" element={<Account />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/admin/messages" element={<AdminMessages />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AuthProvider>
            <AppRouter />
          </AuthProvider>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
